<common-confirm></common-confirm>
<mat-card>
    <h1 class="color-accent">Select inbound location</h1>

    <mat-card-content>
        <form [formGroup]="formGroup">
            <div formArrayName="packages">
                <mat-card *ngFor="let pkg of packagesArray.controls; let i = index" [formGroupName]="i"
                          class="margin-bottom-20">
                    <div class="flex">

                        <div class="icon">
                            <div [class]="this.packages[i].warehouse_package_type?.name"></div>
                        </div>
                        <div class="title">
                            <h2>
                                {{ this.packages[i].warehouse_package_type?.name }} ID:
                                {{ shipment.partner_id === 14 ? "ANPA" : "" }}
                                {{ this.packages[i].id }}

                                <span *ngIf="this.packages[i].linked_ids?.length">
                                | {{ this.packages[i].linked_ids | join: ", " }}
                                </span>

                                <b class="color-accent">
                                    {{ this.packages[i].name }}
                                </b>


                            </h2>

                        </div>

                        <div class="half" *ngIf="!this.inboundComplete && this.outboundComplete">
                            <button mat-raised-button color="accent" type="button" (click)="locationList(i)">
                                {{ pkg.value.location_name ? pkg.value.location_name : "Select location" }}
                            </button>
                        </div>

                    </div>
                </mat-card>
            </div>


            <div class="actions" *ngIf="!this.inboundComplete && this.outboundComplete">
                <button mat-raised-button color="primary" type="button" (click)="submit()">
                    Create kits
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
